import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaCarousel from './VaCarousel.vue'

export const VaCarousel = withConfigTransport(_VaCarousel)
